import { motion } from 'motion/react'
import { Panel, TOKENS } from '../ui/dashboard-primitives'
import { Md } from './Md'

function mondayOf(d: Date): Date {
  const m = new Date(d)
  m.setDate(m.getDate() - ((m.getDay() + 6) % 7))
  m.setHours(0, 0, 0, 0)
  return m
}
function fmt(d: Date): string {
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
function range(weekIndex: number): string {
  const start = mondayOf(new Date())
  start.setDate(start.getDate() + weekIndex * 7)
  const end = new Date(start)
  end.setDate(end.getDate() + 6)
  return `${fmt(start)} – ${fmt(end)}`
}

/**
 * The next four weeks. The plan's per-week facts are free text (decision D-D
 * ships without the session/set chips), so each row is the date range plus the
 * week's instruction.
 */
export function StrategyPanel({ weeks }: { weeks: string[] }) {
  return (
    <Panel variant="light" className="grid mt-2">
      {weeks.slice(0, 4).map((text, i) => (
        <motion.article
          key={i}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.08 }}
          className="grid grid-cols-[2.75rem_1fr] gap-x-4.5"
          style={{
            padding: i === 0 ? '0 0 20px' : i === weeks.length - 1 ? '20px 0 0' : '20px 0',
            borderTop: i === 0 ? undefined : '1px solid ' + TOKENS.creamHairline,
          }}
        >
          <span
            className="text-[1.05rem] font-medium tabular-nums"
            style={{ fontFamily: 'var(--font-mono)', letterSpacing: '-0.02em', color: TOKENS.amber }}
          >
            {String(i + 1).padStart(2, '0')}
          </span>
          <div>
            <span
              className="text-[0.625rem] tracking-[0.2em] uppercase"
              style={{ fontFamily: 'var(--font-mono)', color: TOKENS.cream }}
            >
              {range(i)}
            </span>
            <p className="mt-2 text-[0.9375rem] leading-[1.65]" style={{ color: TOKENS.creamSoft, maxWidth: '82ch' }}>
              <Md>{text}</Md>
            </p>
          </div>
        </motion.article>
      ))}
    </Panel>
  )
}
